import DocumentList from '@/views/support-and-download/components/document-list.vue';
import ProductManuals from '@/views/support-and-download/components/product-manuals.vue';
import VideoList from '@/views/support-and-download/components/video-list.vue';
import { decode } from 'html-entities';
import Model from '../api/model';

// eslint-disable-next-line max-lines-per-function
export function useDocList() {
	// 动态加载的组件列表
	const componentData = ref([]);
	const docLoading = ref( false );
	const getDocList = ( params ) => new Promise(( resolve, reject ) => {
			componentData.value = [];
			docLoading.value = true;
			Model.getDocList( params ).
				then(({ result, status }) => {
					if ( status === 'success' ) {
						if ( result && Array.isArray( result )) {
							// 取出topicName相同的项
							const set = new Set();
							result.forEach(( item ) => {
								set.add( item.topicName );
							});
							set.forEach(( item ) => {
								componentData.value.push({ name: item, list: [] });
							});
							result.forEach(( item ) => {
								item.docName = decode( item.docName );
								item.name = decode( item.name );
								const { list } = componentData.value.find(( component ) => component.name === item.topicName );
								list.push( item );
							});
							docLoading.value = false;
							resolve();
						} else {
							resolve();
						}
					} else {
						reject( result );
					}
				}).
				catch(( e ) => {
					console.log( 'getDocList', e );
					reject( e );
				});
		});
	/**
	 ** 根据产品进阶资料的种类展示不同的形式
	 ** 只有文档时展示同产品手册，只有视频时展示同操作视频，都存在时复合展示
	 */
	const docShow = ( list ) => {
		if ( list.every(( item ) => item.docType === 'video' )) {
			return VideoList;
		} else if (
			list.every(( item ) => item.docType === 'doc' || item.docType === 'other' )
		) {
			return ProductManuals;
		} else {
			return DocumentList;
		}
	};
	return { docShow, componentData, getDocList, docLoading };
}
